// Branding configuration - single source of truth
export const BRAND = {
  name: "Stratel",
  tagline: "Drive results strategically",
  // Stratel teal brand palette
  primary: "#03BCA6", // main brand
  primaryDark: "#037D70",
  primaryLight: "#32CEC0",
  // Logo path (place PNGs at public/branding/stratel-logo-*.png)
  // Use the transparent/dark variant site-wide
  logo: '/branding/stratel-logo-dark.png',
};

export default BRAND;
